import PageWishlist from 'components/account/wishlist';
import Layout from 'components/layout';
import { reformatLocaleToContentfulLocale } from 'lib/utils/helpers';
import { getGlobal } from 'lib/contentful';
import Head from 'next/head';
import { useSalons } from '../hooks';

export default function Page({ locale, globalModules }) {
  useSalons(locale);

  return (
    <Layout locale={locale}>
      <Head>
        <title>{globalModules.wishlist?.title?.text} | Keune Haircosmetics</title>
      </Head>
      <PageWishlist locale={locale} />
    </Layout>
  );
}

export async function getStaticProps({ locale }) {
  const globalModules = await getGlobal(reformatLocaleToContentfulLocale(locale));

  const { hasWebshop } = globalModules?.settings.locale;

  if (!hasWebshop)
    return {
      notFound: true,
    };

  if (!hasWebshop) {
    return {
      notFound: true,
    };
  }

  return {
    props: { locale, globalModules },
  };
}
